/**
 * Main app logo in public folder.
 * Must match a file in public/ (e.g. zeroPath-transparent.png or zeroPath-transparent.jpeg).
 */
const PUBLIC_URL = process.env.PUBLIC_URL || '';
const LOGO_FILENAME = 'zeroPath-transparent.png';
export const APP_LOGO_SRC = `${PUBLIC_URL}/${LOGO_FILENAME}`;
